import { AzureIntegration } from "@p0security/shared/integrations/resources/azure/types";
import { integrationOptionProvider } from "components/Integrations/utils/resourcesInstalledUtil";
import { KnownFirestoreDoc } from "providers/FirestoreProvider";

import { RdpInstaller } from "./types";

export const rdpInstaller = (
  azureDoc: KnownFirestoreDoc<AzureIntegration>
): RdpInstaller => {
  return {
    "iam-write": {
      optionProvider: integrationOptionProvider("iam-write", [
        {
          firestoreRef: azureDoc,
          component: "iam-write",
          labelTitle: "Azure",
          keyPrefix: "azure",
        },
      ]),
    },
  };
};
